// TRIFORCE
export const GLOBALS = {
  triforce: false,
}
